import React, { memo, useMemo } from 'react'

import { VirtualizedList, getSeeAllUrl } from '../CarouselTS'
import { SeeAllCard } from '../Card'

import type { CarouselProps } from './types'

const Carousel = <T,>({
  collection,
  avoidSeeAllCard = false,
  layout,
  onFocus,
  card: Card,
  ttsText,
  index,
  handleInfiniteFetching,
  onLeftExit,
}: CarouselProps<T>) => {
  const data = useMemo<T[]>(
    () => collection?.content || [],
    [collection.content]
  )

  const seeAllUrl = getSeeAllUrl(collection)
  const hasMoreContent =
    !handleInfiniteFetching &&
    !!seeAllUrl &&
    !avoidSeeAllCard &&
    (!!collection?.meta?.links?.next || collection?.content?.length >= 12)
  const dataLength = hasMoreContent ? data.length + 1 : data.length

  return (
    <div className="carousel">
      <VirtualizedList<T>
        data={data}
        hasMoreContent={hasMoreContent}
        ttsText={ttsText}
        layout={layout}
        onFocus={onFocus}
        handleInfiniteFetching={handleInfiniteFetching}
      >
        {({ cards, startIndex, onFocus, handleCardFocus }) =>
          cards.map((card, i) => {
            const key = card.feed_cid ? 'feed_cid' : 'cid'
            return !(card.item_type === 'seeAll') ? (
              <Card
                data={card}
                key={`${index}-${card[key]}`}
                index={startIndex + i}
                onFocus={onFocus}
                onLeftExit={startIndex + i === 0 ? onLeftExit : undefined}
                layout={layout}
                ttsCounterText={`${
                  data.findIndex((c) => c[key] === card[key]) + 1
                } of ${dataLength}`}
              />
            ) : (
              <SeeAllCard
                url={seeAllUrl}
                key={`${index}-seeAll`}
                index={dataLength}
                onFocus={handleCardFocus}
                layout={layout}
                ttsCounterText={`${dataLength} of ${dataLength}`}
              />
            )
          })
        }
      </VirtualizedList>
    </div>
  )
}

export default memo(Carousel)
